package it.maicol07.gamerlogue.`data`

import it.maicol07.spraypaintkt.CollectionProxy
import it.maicol07.spraypaintkt.RecordProxy
import it.maicol07.spraypaintkt.Resource
import it.maicol07.spraypaintkt.ResourceRegistry
import it.maicol07.spraypaintkt.ResourceSerializer
import it.maicol07.spraypaintkt.Scope
import it.maicol07.spraypaintkt.SortDirection
import it.maicol07.spraypaintkt.extensions.DirtyMap
import it.maicol07.spraypaintkt.extensions.trackChanges
import it.maicol07.spraypaintkt.interfaces.JsonApiConfig
import it.maicol07.spraypaintkt.registerResources
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.Number
import kotlin.String
import kotlin.Unit
import kotlin.collections.MutableMap
import kotlin.reflect.KClass
import kotlinx.serialization.Serializable

@Serializable(UserListItem.Companion.Serializer::class)
public class UserListItem : Resource, UserListItemSchema {
  override val `companion`: Resource.CompanionObj<UserListItem> = Companion

  override var id: String? = null

  override var isPersisted: Boolean = false

  override val attributes: DirtyMap<String, Any?> = mutableMapOf<String, Any?>().trackChanges()

  override val relationships: DirtyMap<String, Any?> = mutableMapOf<String, Any?>().trackChanges()

  override val meta: MutableMap<String, Any?> = mutableMapOf()

  override val links: MutableMap<String, Any?> = mutableMapOf()

  override val type: String by lazy { companion.resourceType }

  override var listId: Int
    get() = if (attributes.containsKey("list_id")) {
      attributes["list_id"] as Int
    } else {
      throw NoSuchElementException("listId not found")
    }
    set(`value`) {
      attributes["list_id"] = value
    }

  override var gameId: Int
    get() = if (attributes.containsKey("game_id")) {
      attributes["game_id"] as Int
    } else {
      throw NoSuchElementException("gameId not found")
    }
    set(`value`) {
      attributes["game_id"] = value
    }

  override var position: Int
    get() = if (attributes.containsKey("position")) {
      attributes["position"] as Int
    } else {
      throw NoSuchElementException("position not found")
    }
    set(`value`) {
      attributes["position"] = value
    }

  override var note: String?
    get() = if (attributes.containsKey("note")) {
      attributes["note"] as String?
    } else {
      null
    }
    set(`value`) {
      attributes["note"] = value
    }

  override var createdAt: String?
    get() = if (attributes.containsKey("created_at")) {
      attributes["created_at"] as String?
    } else {
      null
    }
    set(`value`) {
      attributes["created_at"] = value
    }

  override var updatedAt: String?
    get() = if (attributes.containsKey("updated_at")) {
      attributes["updated_at"] as String?
    } else {
      null
    }
    set(`value`) {
      attributes["updated_at"] = value
    }

  public constructor(
    listId: Int? = null,
    gameId: Int? = null,
    position: Int? = null,
    note: String? = null,
    createdAt: String? = null,
    updatedAt: String? = null,
  ) {
    if (listId != null) {
      attributes["list_id"] = listId
    }
    if (gameId != null) {
      attributes["game_id"] = gameId
    }
    if (position != null) {
      attributes["position"] = position
    }
    if (note != null) {
      attributes["note"] = note
    }
    if (createdAt != null) {
      attributes["created_at"] = createdAt
    }
    if (updatedAt != null) {
      attributes["updated_at"] = updatedAt
    }
  }

  public companion object : Resource.CompanionObj<UserListItem> {
    override val resourceType: String = "ListItem"

    override val endpoint: String = "list_items"

    override val config: JsonApiConfig = AppJsonApiConfig

    override val factory: () -> UserListItem = { UserListItem() }

    override val schema: KClass<UserListItemSchema> = UserListItemSchema::class

    init {
      ResourceRegistry.registerResources()
    }

    public fun scope(options: Scope<UserListItem>.() -> Unit = {}): Scope<UserListItem> = Scope(UserListItem::class, options)

    public final suspend fun all(): CollectionProxy<UserListItem> = scope().all()

    public final suspend fun find(id: String): RecordProxy<UserListItem> = scope().find(id)

    public final suspend fun findOrNull(id: String): RecordProxy<UserListItem?> = scope().findOrNull(id)

    public final suspend fun first(): RecordProxy<UserListItem> = scope().first()

    public final suspend fun firstOrNull(): RecordProxy<UserListItem?> = scope().firstOrNull()

    public final suspend fun exists(): Boolean = scope().exists()

    public final suspend fun last(): RecordProxy<UserListItem> = scope().last()

    public final suspend fun lastOrNull(): RecordProxy<UserListItem?> = scope().lastOrNull()

    public final fun page(pageNumber: Number): Scope<UserListItem> = scope().page(pageNumber)

    public final fun per(pageSize: Number): Scope<UserListItem> = scope().per(pageSize)

    public final fun limit(limit: Number): Scope<UserListItem> = scope().limit(limit)

    public final fun offset(offset: Number): Scope<UserListItem> = scope().offset(offset)

    public final fun `where`(attribute: String, `value`: Any): Scope<UserListItem> = scope().where(attribute, value)

    public final fun extraParam(key: String, `value`: String): Scope<UserListItem> = scope().extraParam(key, value)

    public final fun order(attribute: String): Scope<UserListItem> = scope().order(attribute)

    public final fun order(attribute: String, sortDirection: SortDirection): Scope<UserListItem> = scope().order(attribute, sortDirection)

    public final fun includes(vararg relationships: String): Scope<UserListItem> = scope().includes(*relationships)

    public final fun select(type: String, vararg fields: String): Scope<UserListItem> = scope().select(type, *fields)

    public object Serializer : ResourceSerializer<UserListItem>()
  }
}
